import {useState} from "react";
import DetailCompanyRequest from "./DetailCompanyRequest";
import CompanyRequests from "./CompanyRequests";

export default function Index() {

    const [detailId, setDetailId] = useState("")

    return(
        detailId ?
            <DetailCompanyRequest setDetailId={setDetailId} detailId={detailId}/>
            :
            <CompanyRequests setDetailId={setDetailId} />
    )
}